/**
 * The cluster options to set to an existing datasource
 * @link https://maplibre.org/maplibre-gl-js/docs/API/classes/GeoJSONSource/#setdata
 */
export type ClusterSetting = {
    /**
     * A boolean indicating if Point features in the source should be clustered or not.
     * If set to true, points will be clustered together into groups by radius.
     * default `false`
     * @default false
     */
    cluster: boolean;
    /**
     * The radius of each cluster in pixels.
     * default `50`
     * @default 50
     */
    clusterRadius: number;
    /**
     * The maximum zoom level in which to cluster points.
     * Defaults to one zoom less than `maxZoom` so that last zoom features are not clustered.
     */
    clusterMaxZoom: number;
};

/*
 * See also:
 *      DatasourceManager.ts#clusterRadiusAdjustedForSymbolSize
 *      com.espatial.es.model.layer.styleSettings.ClusterSettings
 */
const ClusterSettings = {
    OFF: {cluster: false} as ClusterSetting,
    STANDARD:  {cluster: true,  clusterRadius: 1, clusterMaxZoom: 22} as ClusterSetting,
    // todo: clusterRadius: 24 might be a better value here
    PIE: {cluster: true,  clusterRadius: 14, clusterMaxZoom: 22} as ClusterSetting,
}

export function getClusterSetting(type: string): ClusterSetting {
    if(ClusterSettings[type]){
        return es.util.object.deepCopy(ClusterSettings[type]);
    }
    throw new Error("getClusterSetting called with invalid type: " + getClusterSetting);
}
